import { ElementPlugin } from '../Element/plugin'
import { ElementComponentComponent } from './ElementComponent'
import { SchemaComponentDefinition } from './SchemaDefinition'
import { ComponentDefinition } from './TypedDefinition'
import { ComponentNode } from './TypedNode'

import type { PluginLike, PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface ComponentPluginProps {}

export class ComponentPlugin implements RehajePlugin {
  plugins?: PluginLike[] = [
    new ElementPlugin({
      components: {
        Component: ElementComponentComponent
      }
    })
  ]

  props: ComponentPluginProps

  visitors: PluginVisitors

  constructor(props?: ComponentPluginProps) {
    this.props = { ...props }
    this.visitors = {
      definitions: {
        Component: ComponentDefinition,
        'Schema.Component': SchemaComponentDefinition
      },
      nodes: {
        Component: ComponentNode
      }
    }
  }
}
